export const formatTimezone = (timezone: string | undefined) => {
  if (!timezone) return '-';
  return timezone.split('/').pop()?.replace(/_/g, ' ') || timezone;
};

/**
 * Compacta "GMT+01:00" → "GMT+1"; UTC explícito (evita "GMT" ambiguo de shortOffset).
 */
function compactLongGmtOffset(longOffset: string): string {
  if (longOffset === 'GMT+00:00' || longOffset === 'GMT-00:00') return 'UTC';
  const m = longOffset.match(/^GMT([+-])(\d{1,2}):(\d{2})$/);
  if (m) {
    const sign = m[1];
    const h = parseInt(m[2], 10);
    const min = parseInt(m[3], 10);
    if (min === 0) return `GMT${sign}${h}`;
  }
  return longOffset;
}

/**
 * Formato corto para columnas: GMT+1, GMT-3, UTC…
 * Prioriza `longOffset` (offset numérico claro); si no existe en el motor, cae a `shortOffset`.
 */
export const formatTimezoneShort = (timezone: string | undefined): string => {
  if (!timezone) return '-';
  const iana = timezone.trim();
  if (!iana) return '-';

  const ref = new Date();

  try {
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: iana,
      timeZoneName: 'longOffset',
    });
    const parts = formatter.formatToParts(ref);
    const tzPart = parts.find((p) => p.type === 'timeZoneName')?.value;
    if (tzPart) return compactLongGmtOffset(tzPart);
  } catch {
    // seguir
  }

  try {
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: iana,
      timeZoneName: 'shortOffset',
    });
    const parts = formatter.formatToParts(ref);
    const tzPart = parts.find((p) => p.type === 'timeZoneName')?.value;
    if (tzPart) {
      if (tzPart === 'GMT' && (iana === 'UTC' || iana === 'Etc/UTC' || iana === 'Etc/GMT')) {
        return 'UTC';
      }
      return tzPart;
    }
  } catch {
    // seguir
  }

  return iana.split('/').pop()?.replace(/_/g, ' ') || iana;
};
